import React from 'react';
import { Filter } from './styles';
import { MdFilterList } from 'react-icons/md';

const FilterButton = props => {
  const { submit, onClick } = props;
  return (
    <Filter data-testid="filter-button" submit={submit} onClick={onClick}>
      <MdFilterList />
      Filtrar
    </Filter>
  );
};

export default FilterButton;
